module.exports = __webpack_public_path__ + "static/img/download_ios.896149f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download_ios.png
// module id = oD6L
// module chunks = 1